// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const ContractJobViewLayout = ({ children }) => {

	return (
		<div className='ContractJobViewLayout'>
			
			<Header/>

			<Container>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ContractJobViewLayout.propTypes = {
	children: PropTypes.node,
}

ContractJobViewLayout.defaultProps = {
	children: null,
}

export default ContractJobViewLayout;